/**
 * Color utility functions for consistent color assignment
 */

// Color palette for consistent color assignments
export const TW_COLOR_PALETTE = [
  "bg-[#6AC9FF]", // Light Blue
  "bg-[#2ED667]", // Green
  "bg-[#FB8E29]", // Orange
  "bg-[#FF5E5E]", // Red
  "bg-[#FFCA3F]", // Yellow
  "bg-[#2A70EA]", // Blue
  "bg-[#A659FF]", // Purple
  "bg-[#FF6DCC]", // Pink
  "bg-[#439EBD]", // Teal
  "bg-[#774C4C]", // Brown
];

/**
 * Get a color from the palette based on a string identifier
 * @param identifier Any string to use as a unique identifier
 * @returns A color from the palette
 */
export function getColorFromString(identifier: string): string {
  const hash = identifier.split("").reduce((acc, char) => {
    return acc + char.charCodeAt(0);
  }, 0);

  return TW_COLOR_PALETTE[hash % TW_COLOR_PALETTE.length];
}

/**
 * Get a color from the palette based on a numeric index
 * @param index Numeric index
 * @returns A color from the palette
 */
export function getColorFromIndex(index: number): string {
  // Ensure positive index
  const positiveIndex = Math.abs(index);
  return TW_COLOR_PALETTE[positiveIndex % TW_COLOR_PALETTE.length];
}

/**
 * Get a random color from the palette
 * @returns A random color from the palette
 */
export function getRandomColor(): string {
  const randomIndex = Math.floor(Math.random() * TW_COLOR_PALETTE.length);
  return TW_COLOR_PALETTE[randomIndex];
}
